/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EmailNotificationResponse } from './EmailNotificationResponse';
import {
    EmailNotificationResponseFromJSON,
    EmailNotificationResponseFromJSONTyped,
    EmailNotificationResponseToJSON,
    EmailNotificationResponseToJSONTyped,
} from './EmailNotificationResponse';

/**
 * 
 * @export
 * @interface ResultOfEmailNotificationResponse
 */
export interface ResultOfEmailNotificationResponse {
    /**
     * 
     * @type {EmailNotificationResponse}
     * @memberof ResultOfEmailNotificationResponse
     */
    data: EmailNotificationResponse | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResultOfEmailNotificationResponse
     */
    isSuccess: boolean;
    /**
     * 
     * @type {Error}
     * @memberof ResultOfEmailNotificationResponse
     */
    error: Error | null;
}

/**
 * Check if a given object implements the ResultOfEmailNotificationResponse interface.
 */
export function instanceOfResultOfEmailNotificationResponse(value: object): value is ResultOfEmailNotificationResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ResultOfEmailNotificationResponseFromJSON(json: any): ResultOfEmailNotificationResponse {
    return ResultOfEmailNotificationResponseFromJSONTyped(json, false);
}

export function ResultOfEmailNotificationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfEmailNotificationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': EmailNotificationResponseFromJSON(json['data']),
        'isSuccess': json['isSuccess'],
        'error': json['error'],
    };
}

export function ResultOfEmailNotificationResponseToJSON(json: any): ResultOfEmailNotificationResponse {
    return ResultOfEmailNotificationResponseToJSONTyped(json, false);
}

export function ResultOfEmailNotificationResponseToJSONTyped(value?: ResultOfEmailNotificationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': EmailNotificationResponseToJSON(value['data']),
        'isSuccess': value['isSuccess'],
        'error': value['error'],
    };
}

